import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection, NamedProperty } from "sprint-common-web";

import { GetIntegratorsLookupResponse } from "../../../admin/integrator/api/GetIntegratorsLookupResponse";
import { useAdminIntegratorApi } from "../../../admin/integrator/api/useAdminIntegratorApi";
import { Integrator, mapToIntegrator } from "../../types/Integrator";

interface IIntegratorsDataContext {
    integrators: NamedProperty[];
    isLoading: boolean;
}

export const IntegratorsDataContext = createContext<IIntegratorsDataContext>({
    integrators: [],
    isLoading: true
});

type IntegratorsDataProviderProps = React.PropsWithChildren<unknown>;

export const IntegratorsDataProvider: React.FunctionComponent<IntegratorsDataProviderProps> = ({
    children
}: IntegratorsDataProviderProps) => {
    const [integrators, setIntegrators] = useState<Integrator[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { getIntegratorsLookup } = useAdminIntegratorApi();

    useEffect(() => {
        setIsLoading(true);

        getIntegratorsLookup()
            .then((response: GetIntegratorsLookupResponse) => {
                const integratorList = response.items.map(mapToIntegrator);
                const sortedItems = getSortedCollection(integratorList, "name");

                setIntegrators(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <IntegratorsDataContext.Provider value={{ integrators, isLoading }}>{children}</IntegratorsDataContext.Provider>
    );
};
